// @flow

// Components
import VersionComponent from 'hfty-version'

// Image
import logo from 'hfty-images/src/FE_Soils_Logo_WhiteBg.png'

// Libs
import React from 'react'

// Styles
import { primary, white } from 'hfty-styles/src/colors'

const styles = {
  container: {
    boxShadow: '0 1px 1px rgba(0, 0, 0, 0.1)',
  },
  top: {
    minHeight: 50,
    padding: 10,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundOrigin: 'content-box',
    backgroundColor: primary(),
    backgroundImage: `url(${logo})`,
    backgroundPosition: 'center',
    display: 'flex',
  },
  selectors: {
    display: 'flex',
    justifyContent: 'space-between',
    alignSelf: 'flex-end',
    marginTop: '20px',
  },
  image: {
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left 10px center',
  },
  notAuthenticated: {
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left 10px center',
    margin: '20px 0',
  },
  widget: {
    fontSize: '0.7em',
    fontWeight: 500,
    textTransform: 'uppercase',
    marginRight: 10,
    alignSelf: 'flex-start',
    color: white(),
    display: 'block',
    position: 'absolute',
    right: '20px',
  },
  logoutBtn: {
    marginTop: 3,
    cursor: 'pointer',
  },
  version: {
    marginTop: 3,
    fontStyle: 'italic',
  },
}

function onLogout(logout: Function, push: Function) {
  push('/')
  logout()
}

// User Widge
function UserWidget(props: { userlabel: string, logout: Function, push: Function }): ?React.Element<any> {
  if (props.userlabel) {
    return (
      <div data-test="hfty-layout/UserWidget" style={styles.widget}>
        <div>{props.userlabel}</div>
        <div role="button" style={styles.logoutBtn} onClick={(): Function => onLogout(props.logout, props.push)}>
          Logout
        </div>
        <VersionComponent style={styles.version} />
      </div>
    )
  }

  return null
}
// Types
type Props = {
  children?: ?React.Element<any>,
  isAuthenticated: boolean,
  userlabel: string,
  logout: Function,
  push: Function,
}

export default function TopBar(props: Props): ?React.Element<any> {
  if (!props.isAuthenticated) {
    return null
  }
  return (
    <div style={styles.container}>
      <div style={styles.top}>
        <UserWidget userlabel={props.userlabel} logout={props.logout} push={props.push} />
      </div>
      {props.children}
    </div>
  )
}
